import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-no-results',
  templateUrl: './no-results.component.html',
  styleUrls: ['./no-results.component.scss'],
  standalone: false
})
export class NoResultsComponent {
  subscriptions: Array<Subscription> = [];

  @Input() message = 'no-results-text';

  constructor() {}
}
